import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { CollectionButtonController } from './CollectionButtonController';
import { CollectionButtonProps } from './ICollectionButton';
import { StyledButton } from '../CollectionStyles';
import { useTranslation } from '~sharedComponents/Providers/Translations/TranslationsHook';

const translationArray = ['loading', 'saveForLater', 'remove'];

export const CollectionButton: React.FC<CollectionButtonProps> = observer(
    (props: CollectionButtonProps) => {
        const { collectionName, sku } = props;
        const { loading, saveForLater, remove } = useTranslation(translationArray);

        const [controller] = useState(new CollectionButtonController({ collectionName, sku }));

        const { isLoading, addItem, removeItem, isInCollection } = controller;

        const inCollection = isInCollection();
        const showAddItem = !isLoading && !inCollection;
        const showRemoveItem =
            !isLoading && inCollection && remove && remove.substring(0, 2) !== '::';

        return (
            <>
                {isLoading && <div>{loading}</div>}
                {showRemoveItem && (
                    <StyledButton onKeyPress={removeItem} onClick={removeItem}>
                        {remove}
                    </StyledButton>
                )}
                {showAddItem && (
                    <StyledButton onKeyPress={addItem} onClick={addItem}>
                        {saveForLater}
                    </StyledButton>
                )}
            </>
        );
    }
);
